import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white border-b border-black/10' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 sm:px-10 py-5 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer">
          <div className="w-9 h-9 bg-black rounded-md flex items-center justify-center">
            <span className="text-[#F5C518] font-black text-xs tracking-tight">RD</span>
          </div>
          <span className={`font-black text-sm tracking-widest uppercase transition-colors ${scrolled ? 'text-black' : 'text-black'}`}>
            HELP CENTER
          </span>
        </Link>

        {/* Desktop nav — empty, just spacing placeholder */}
        <nav className="hidden md:flex items-center" />
      </div>
    </header>
  );
}
